'use client';

import { useCallback } from 'react';

import { useAuthContext } from 'src/auth/hooks';

/**
 * **워크스페이스를 바꾸는 한 길** — 사용자 문서의 `lastWorkspace` 를 고른 값으로 적는다.
 *
 * 🔑 사이드바 고르개와 설정 머리의 전환기가 이 훅 하나를 쓴다 — 바꾸면 인증 문맥이 목록을 다시 읽고
 *   (`auth-provider` 의 `lastWorkspace` 효과) 화면들이 새 워크스페이스로 다시 선다. 주소는 그대로다.
 * ⛔ 라우트로 바꾸지 마라 — `/service/workspace/{id}` 는 `lastWorkspace` 를 안 바꾸고 옛 화면만 연다.
 * ⚠️ 이미 그 값이면 쓰지 않는다 — 같은 값을 되쓰는 Firestore 쓰기가 나간다.
 */
export function useSwitchWorkspace() {
  const { user, authenticated, updateProfile } = useAuthContext();
  const current = String(user?.lastWorkspace ?? '').trim();

  /** @returns 실제로 바꿨으면 참 */
  const switchTo = useCallback(
    (id: string | null | undefined): boolean => {
      const next = String(id ?? '').trim();
      if (!next || !authenticated || next === current || !updateProfile) return false;
      updateProfile({ lastWorkspace: next }, true);
      return true;
    },
    [authenticated, current, updateProfile],
  );

  return { currentId: current, switchTo };
}
